// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2jL0x","dragIcon":"SortableItem_dragIcon__3kp4h","disabled":"SortableItem_disabled__1OJKI"};